import { render, staticRenderFns } from "./ListLedger.vue?vue&type=template&id=0b0b7544&lang=pug&"
import script from "./ListLedger.vue?vue&type=script&lang=js&"
export * from "./ListLedger.vue?vue&type=script&lang=js&"
import style0 from "./ListLedger.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ListLedger.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VIcon,
})
